import React, {Component} from 'react';
import FunduLogo from '../svg/FunduLogo';
import ArrowRight from '../svg/ArrowRight';
import heroBanner from 'assets/images/hero-banner.png';
import heroBannerMobile from 'assets/images/hero-banner-mobile.png';
import Footnotes from '../footnotes/Footnotes';
import APIRequest from 'api/APIRequest';
import {getLocalizedStrings} from 'locale/i18n';

import './Home.scss';
import {connect} from "react-redux";

class Home extends Component {
  constructor (...args) {
    super(...args);
    this.state = {
      blogPosts: []
    };
    this._isMounted = false;
  }

  strip (html) {
    let doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  }

  getBlogPosts () {
    this.api = new APIRequest();
    this.api.getBlogPosts().then((data) => {
      if (!this._isMounted) return;

      const posts = data.map((item) => {
        return {
          id: item.id,
          title: this.strip(item.title.rendered),
          description: this.strip(item.excerpt.rendered),
          image: item.yoast_head_json.og_image[0]?.url,
          link: item.link,
        };
      });

      this.setState({
        blogPosts: posts ?? [],
      });
    });
  }

  componentDidMount() {
    this._isMounted = true;
    this.getBlogPosts();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render () {
    const {app} = this.props;
    const strings = getLocalizedStrings(app?.config?.lang);
    const logoUrl = app?.config?.main?.logoUrl;
    return (
      <div className='fade-animation'>
        <div className="home">
          <header className="header container">
            <a className="logo" href="/">
              {logoUrl ? <img src={logoUrl} className={'custom'} alt={''}/> :
                <FunduLogo className="logo"/>}
            </a>
          </header>
          <section className="hero-banner hide-on-xs">
            <picture>
                <source srcSet={heroBanner} media="(min-width: 1120px)"/>
                <img src={heroBannerMobile} alt="Fundu banner"/>
            </picture>
          </section>
          <section className="hero-form-container container">
            <div className="hero-form">
              <h1 className="h2 md-h1 title hide-on-xs">{strings['home-hero-title']}</h1>
              <div className="form-container">
                <div className="form-search">
                  <div className="input-header">
                    <h2 className="h6 md-h2 heading">{strings['home-search-title']}</h2>
                    <p className="message body4 md-h6">{strings['home-search-message']}</p>
                  </div>
                  <div className="input-content">
                    <label className="label body4 md-body2">{strings['home-search-label']}</label>
                    <div className="start-container ">
                      {this.props.children}
                    </div>
                  </div>
                  <Footnotes/>
                </div>
                <div className="form-info hide-on-xs">
                  <h3 className="heading h6 md-h4">{strings['home-steps-title']}</h3>
                  <div className="info-steps">
                    {strings['home-steps'].map((item, index) => (
                      <div key={`step-${index}`} className="info-step-item">
                        <div className="step">
                          <div className="circle body1">{index+1}</div>
                        </div>
                        <div className="content">
                          <h4 className="heading h6">{item.title}</h4>
                          <p className="text body2">{item['sub-title']}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {this.state.blogPosts.length > 0 &&
            <section className="container hide-on-xs">
              <div className="blog-section">
                <h2 className="blog-title h6 md-h2">{strings['home-blog-title']}</h2>
                <div className="articles">
                  {this.state.blogPosts.map((post) => (
                    <article key={post.id} className="article">
                      <a href={post.link} target="_blank" rel="noopener noreferrer" className="article-image">
                        <img src={post.image} alt={post.title}/>
                      </a>
                      <h3 className="title h6">{post.title}</h3>
                      <p className="body3 description">{post.description}</p>
                      <a className="link" href={post.link} target="_blank" rel="noopener noreferrer">
                        {strings['home-blog-link']}
                        <span className="icon"><ArrowRight/></span>
                      </a>
                    </article>
                  ))}
                </div>
              </div>
            </section>}

          <footer className="footer hide-on-xs">
            <div className="container wrapper">
              <div className="footer-info">
                <h5 className="title h6 md-h5">{strings['home-footer-header']}</h5>
                <p className="address body3 md-body2">{strings['home-footer-address']}</p>
                <a href={strings['home-footer-link-url']} className="link" target="_blank" rel="noopener noreferrer">{strings['home-footer-link']} <ArrowRight/></a>
              </div>
              <div className="footer-quote">
                <p className="text h4">{strings['home-footer-quote']}</p>
              </div>
            </div>
            <div className="footer-copyright">
              <p className="text body4">&copy; {strings['home-footer-copyright']}</p>
            </div>
          </footer>
        </div>
      </div>
    );
  }
}
export default connect(state => ({app: state.app}))(Home);
